import {GlobalAnalyticsVariablesInterface, TrackInputFieldSelectionInterface} from '../interfaces';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';

export const trackInputFieldSelectionPayloadCase = (
  payload: any,
  globalVariables?: GlobalAnalyticsVariablesInterface,
): TrackInputFieldSelectionInterface => {
  const data = {
    currentPage: payload.currentPage,
    interaction: `checkin:${payload.fieldName}`,
    eventType: 'interaction',
  };
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
};
